<template>
  <div class="product-list-box">
    <empty v-if="isEmpty" emptyText="暂无数据"></empty>
    <div class="product-list" v-else>
      <product-list-item
        v-for="item in productList"
        :key="item.visa_product_id"
        :product="item"
      ></product-list-item>
    </div>
  </div>
</template>

<script>
import Empty from '@/pages/work-wx/components/empty.vue';
import ProductListItem from './components/product-item';

export default {
  components: {
    ProductListItem,
    Empty,
  },
  props: {
    productList: Array,
  },
  data() {
    return {
      isEmpty: false,
    };
  },
  watch: {
    productList: {
      handler(val) {
        if (val && val.length > 0) {
          this.isEmpty = false;
        } else {
          this.isEmpty = true;
        }
      },
      immediate: true,
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.product-list-box {
  margin-top: 20px;
  .nodata {
    text-align: center;
    font-size: 16px;
    color: #91999f;
  }
}
</style>
